import { render, staticRenderFns } from "./AdvancedPagination.vue?vue&type=template&id=35759ca0&scoped=true"
import script from "./AdvancedPagination.vue?vue&type=script&lang=js"
export * from "./AdvancedPagination.vue?vue&type=script&lang=js"
import style0 from "./AdvancedPagination.vue?vue&type=style&index=0&id=35759ca0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35759ca0",
  null
  
)

export default component.exports